import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-nav-tabs-btn as-nav-tabs-btn__border" }
const _hoisted_2 = { class: "as-tab-content" }
const _hoisted_3 = { class: "as-statistics__content" }
const _hoisted_4 = { class: "as-statistics__value as-statistics__value--home" }
const _hoisted_5 = { class: "as-statistics__bar-wrapper as-statistics__bar-wrapper--home" }
const _hoisted_6 = { class: "as-statistics__bar as-statistics__bar--home" }
const _hoisted_7 = { class: "as-statistics__title" }
const _hoisted_8 = { class: "as-statistics__bar-wrapper as-statistics__bar-wrapper--away" }
const _hoisted_9 = { class: "as-statistics__bar as-statistics__bar--away" }
const _hoisted_10 = { class: "as-statistics__value as-statistics__value--away" }

import { computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";


const __default__ = {};

interface IProps {
  isHomePage?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StatisticsListSkeleton',
  props: {
    isHomePage: { type: Boolean, default: false }
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
    { 'as-statistic-home': _ctx.isHomePage },
    `as-parent-statics as-parent-statics-${siteName.value}`,
  ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
        return _createElementVNode("div", { key: index }, [
          _createVNode(SkeletonLoader, {
            width: "65px",
            height: "30px",
            line: 1
          })
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["as-statistics", {
        'as-scrolling as-scrolling__have-tab as-scrolling__result-popup': !_ctx.isHomePage,
        'as-home-scrollable-content': _ctx.isHomePage,
      }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (index) => {
            return _createElementVNode("div", {
              class: "as-statistics__line",
              key: index
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(SkeletonLoader, {
                  width: "30px",
                  height: "10px",
                  line: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(SkeletonLoader, {
                    width: "100px",
                    height: "10px",
                    line: 1
                  })
                ])
              ]),
              _createElementVNode("span", _hoisted_7, [
                _createVNode(SkeletonLoader, {
                  width: "80px",
                  height: "10px",
                  line: 1
                })
              ]),
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(SkeletonLoader, {
                    width: "100px",
                    height: "10px",
                    line: 1
                  })
                ])
              ]),
              _createElementVNode("span", _hoisted_10, [
                _createVNode(SkeletonLoader, {
                  width: "30px",
                  height: "10px",
                  line: 1
                })
              ])
            ])
          }), 64))
        ])
      ], 2)
    ])
  ], 2))
}
}

})